import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../router/paths.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import { useTranslation } from 'react-i18next';
import Button from '@components/atoms/ui-kit/button.tsx';
import { useThemeContext } from '@utils/hooks/use-theme-context.ts';

type Props = {
  error: AxiosError<BaseError> | null;
};

const DocumentNotFound = ({ error }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getColour } = useThemeContext();

  const goHome = () => {
    navigate(PATHS().HOME);
  };

  return (
    <div
      className="flex items-center justify-center h-screen"
      style={{ backgroundColor: getColour('baseLayer') }}
    >
      <div
        className="text-center p-8 rounded-2xl shadow-md max-w-md w-full mx-3 border"
        style={{
          backgroundColor: getColour('thirdLayer'),
          borderColor: getColour('border')
        }}
      >
        <h1
          className="text-3xl font-bold mb-4"
          style={{ color: getColour('normalText') }}
        >
          {t('document-not-found')}
        </h1>
        <p className="mb-6" style={{ color: getColour('inactiveText') }}>
          {t(
            'sorry-the-document-you-are-looking-for-does-not-exist-or-an-error-has-occurred-while-transcribing-the-document'
          )}
        </p>
        {error && (
          <p className="text-orange-600 dark:text-orange-400">
            Reason:{' '}
            {error.response?.data?.error?.toUpperCase() ||
              t('an-error-has-occurred')}
          </p>
        )}
        {error && error.response?.data?.error_description && (
          <p className="mb-6 text-orange-600 dark:text-orange-400">
            {t('description')}: {error.response.data.error_description}
          </p>
        )}
        <Button
          onClick={goHome}
          type="button"
          size={'large'}
          variant={'primary'}
        >
          {t('go-back-to-home')}
        </Button>
      </div>
    </div>
  );
};

export default DocumentNotFound;
